import type { TSearchIndexes } from '@klv/molecules/unified-search-results/types';

const algoliaIndexes: { [key: string]: TSearchIndexes; } = {
  academyIndex: 'academy_courses',
  communitIndex: 'community_forum_questions',
  developerIndex: 'dev_portal',
  helpCenterIndex: 'help_center_articles',
  marketingSiteIndex: 'marketing_sites',
  // The all resources index is a singular index that unifies all resources (except community)
  allResourcesIndex: 'TEST_UNIFIED_INDEX',
};

export default algoliaIndexes;
